import * as rudderstack from 'rudder-sdk-js';

export const initRudderstack = () => {
  rudderstack.load(
    process.env.REACT_APP_RUDDERSTACK_WRITE_KEY!,
    process.env.REACT_APP_RUDDERSTACK_DATE_PLANE_URL!
  );
};

export const identifyRudderstackUser = (user: {
  id: string;
  first_name: string;
  last_name: string;
  company: { id: string };
  settings: { location_id: string };
}) => {
  rudderstack.identify(user.id, {
    first_name: user.first_name,
    last_name: user.last_name,
    company: user.company.id,
    location: user.settings.location_id,
  });
};

export const logRudderstackEvent = (
  event: string,
  properties: rudderstack.apiObject
) => {
  rudderstack.track(event, properties);
};
